'use client'

import { useEffect, useRef, useState } from "react";
import styles from './ua.module.scss'
import FormCell from "@/components/form/FieldCell";
import FormCells from "@/components/form/FieldCells";
import Form from "@/components/form/Form";
import PanelBody from "@/components/panel/PanelBody";
import PanelHeader from "@/components/panel/PanelHeader";
import PanelTitle from "@/components/panel/PanelTitle";
import StackedPanel from "@/components/panel/StackedPanel";
import Tabs from "@/components/tab/Tabs";
import { DMField, DM_ERROR, DM_EVENT_TRADE_ESTIMATE, DM_EVENT_TRADE_VEHICLE_UPDATE, DM_FIELDS, DM_FORM_ERROR, useDMEventListener } from "@dealermesh/react";
import FieldLabel from "@/components/form/FieldLabel";
import Field from "@/components/form/Field";
import Button from "@/components/button/Button";
import { formatCurrency, formatNumber } from "@/utils/Formatters";
import ApiUtils from "@/utils/ApiUtils";
import useEventListener, { emitEvent } from "@/components/plugins/EventListener";
import Disclaimer from "@/components/panel/Disclaimer";
import Icon from "@/components/icon/Icon";
import LeadForm from "../lead/LeadForm";

export default function TradeForm(props) {
  
  const {site, close, onEstimate} = props
  const leadGated = site.trade.lead?.behavior == 'required' && !site.session?.lead?.customer_id
  const steps = ["trim", ...(site.trade.step_options ? ['options'] : []), ...(leadGated ? ['contact'] : [])]
  
  const panelOffer = useRef()
  const form = useRef()
  
  const [vehType,setVehType] = useState(site.trade.vid_types[0].type)
  const [estimate, setEstimate] = useState()
  const [vehicle,setVehicle] = useState()
  const [editMode, setEditMode] = useState(false)
  const [error, setError] = useState()
  const [leadFormVisible,setLeadFormVisible] = useState(false)
  const [leadAvailable,setLeadAvailable] = useState(site.session?.lead?.customer_id != null)

  useDMEventListener(DM_ERROR, event => {
    if (event.detail?.code != "000500") {
      setError(event.detail.message)
    }
  })

  useDMEventListener(DM_EVENT_TRADE_VEHICLE_UPDATE, event => {
    console.log("VEH", event.detail.vehicle)
    setVehicle(event.detail.vehicle)
    if (leadAvailable) {
      form.current.call("getEstimate", null, { vehicle: event.detail })
    } else {
      setLeadFormVisible(leadGated)
    }
  })
  
  useDMEventListener(DM_FORM_ERROR, event => {
    if (event.detail.form == 'trade') setError(event.detail.errors[0].message)
  })

  useEventListener("lead_sync", event => {
    if (event.detail?.customer_id) setLeadAvailable(true)
  })

  useEffect(() => {
    emitEvent("lead_sync_request")
  }, [])

  const onVehicleTypeChange = (tab) => {
    setVehType(tab.type)
    // form.current.call("setVehicleIdType", tab.type)
  }
  
  const onVehicleSubmit = (event) => {
    if (event.event == DM_EVENT_TRADE_ESTIMATE) {
      if (event.estimate.input_mileage) event.estimate.mileage = event.estimate.input_mileage
      setVehicle(event.estimate.vehicle)
      setLeadFormVisible(false)
      if (panelOffer?.current) panelOffer.current.scrollIntoView()
      if (!estimate || site.session?.vehicles?.trade?.value != event.estimate.value) {
        ApiUtils.postRequest("/api/visitor/track", { 
          payload: { 
            dr: { 
              tradeInValue: event.estimate.value,
              tradeInPayoff: event.estimate.payoff,
            },
            trade: {
              trade_id: event.estimate.trade_id,
              year: event.estimate.vehicle.year,
              make_name: event.estimate.vehicle.make_name,
              model_name: event.estimate.vehicle.model_name,
              trim_name: event.estimate.vehicle.trim_name,
              name: event.estimate.vehicle.name,
              value: event.estimate.value,
              value_low: event.estimate.value_low,
              value_high: event.estimate.value_high,
            }
          } 
        })
        if (typeof onEstimate == 'function') {
          onEstimate(event.estimate)
        }
      }
     // We set the estimated value only when form is not it editMode.
      if((!editMode) || (site.page_name != 'trade' && !event.current)) {
        setEstimate(event.estimate)
      }
      // If a trade is submitted, we set `editMode` to false.
      if (event.editMode == false) {
        setEditMode(false)
      }
      if (event.estimate.vin) setVehType('vin')
    }
  }

  const onSubmit = (e) => {
    e.preventDefault()
    if (leadGated && !leadAvailable) {
      setLeadFormVisible(true)
    } else {
      const form = e.target.form
      form.submit()
    }
  }
  
  const reset = () => {
    setEditMode(true)
    setEstimate(null)
  }

  const showLeadForm = () => {
    emitEvent("show_lead_form_slide", { trade: estimate })
  }
  
  const remove = (e) => {
    e.preventDefault()
    ApiUtils.postRequest("/api/visitor/track", {
      payload: { 
        site: site.site_id,
        dr: { 
          tradeInValue: 0,
        },
        trade: {
          trade_id: estimate.trade_id
        }
      } 
    }).then(data => {
      setEditMode(false)
      setTimeout(() => {
        setEstimate(null)
      }, 1000)
      if (typeof onEstimate == 'function') {
        onEstimate({})
      }
      emitEvent("trade_removed")
      if (typeof close === 'function' ) {
        close()
      }
    })
  }

  const edit = () => {
    setEditMode(true)
    setEstimate(null)
  }

  const onLeadSubmit = (data) => {
    setLeadAvailable(true)
    form.current.call("getEstimate")
  }
  
  return (
    <div className={ styles.Panel }>
        {(!estimate || editMode) &&
          <section style={leadFormVisible ? { display: 'none' } : {}}>
            <Form ref={form} id="trade_form" name="Trade Form" form="trade" vehType={vehType} steps={steps} onFormSubmit={data => onVehicleSubmit(data)}>
              <FormCells>
                <FormCell>
                </FormCell>
                <FormCell>
                  <h2 className="h2 text-align-center">{site.trade.form_header}</h2>
                  <div className="text-align-center">{site.trade.form_sub_header}</div>
                </FormCell>
                <FormCell>
                  <Field type="hidden" name={DM_FIELDS.TRADE_VEHICLE_ID_TYPE} value={vehType}></Field>
                  <Tabs items={site.trade.vid_types} selected={vehType} onChange={tab => onVehicleTypeChange(tab)}></Tabs>
                </FormCell>
                {error &&
                  <FormCell>
                    <span className="text-red text-bold text-align-center">{error}</span>
                  </FormCell>
                }
                {vehType == 'plate' &&
                  <FormCell size="50">
                    <FieldLabel for={DM_FIELDS.TRADE_VEHICLE_PLATE}>Plate Number</FieldLabel>
                    <Field>
                      <DMField name={DM_FIELDS.TRADE_VEHICLE_PLATE}></DMField>
                    </Field>
                  </FormCell>
                }
                {vehType == 'plate' &&
                  <FormCell size="50">
                    <FieldLabel for={DM_FIELDS.TRADE_VEHICLE_STATE}>State</FieldLabel>
                    <Field>
                      <DMField name={DM_FIELDS.TRADE_VEHICLE_STATE}></DMField>
                    </Field>
                  </FormCell>
                }
                {vehType == 'vin' &&
                  <FormCell>
                    <FieldLabel for={DM_FIELDS.TRADE_VEHICLE_VIN}>VIN</FieldLabel>
                    <Field>
                      <DMField name={DM_FIELDS.TRADE_VEHICLE_VIN} value={estimate?.vin}></DMField>
                    </Field>
                  </FormCell>
                }
                {vehType == 'ymmt' &&
                  <FormCell>
                    <FieldLabel for={DM_FIELDS.TRADE_VEHICLE_VIN}>VIN</FieldLabel>
                    <Field>
                      <DMField name={DM_FIELDS.TRADE_VEHICLE_VIN}></DMField>
                    </Field>
                  </FormCell>
                }
                <FormCell size="50">
                  <FieldLabel for={DM_FIELDS.TRADE_VEHICLE_MILES}>Mileage</FieldLabel>
                  <Field>
                    <DMField name={DM_FIELDS.TRADE_VEHICLE_MILES} value={estimate?.input_mileage}></DMField>
                  </Field>
                </FormCell>
                <FormCell size="50">
                  <FieldLabel for={DM_FIELDS.TRADE_VEHICLE_CONDITION}>Condition</FieldLabel>
                  <Field>
                    <DMField name={DM_FIELDS.TRADE_VEHICLE_CONDITION} value={estimate?.condition}></DMField>
                  </Field>
                </FormCell>
                <FormCell size="50">
                  <FieldLabel for={DM_FIELDS.TRADE_VEHICLE_PAYOFF}>Payoff</FieldLabel>
                  <Field>
                    <DMField name={DM_FIELDS.TRADE_VEHICLE_PAYOFF} value={estimate?.payoff || '0'}></DMField>
                  </Field>
                </FormCell>
                <FormCell size="50">
                  <FieldLabel for={DM_FIELDS.TRADE_VEHICLE_ZIP}>Zip</FieldLabel>
                  <Field>
                    <DMField name={DM_FIELDS.TRADE_VEHICLE_ZIP} value={estimate?.zip}></DMField>
                  </Field>
                </FormCell>
                <FormCell>
                  <Button type="submit" theme={['primary', 'inline']} label={'Continue'}></Button>
                </FormCell>
              </FormCells>
            </Form>
          </section>
        }
        {((estimate && !editMode) || leadFormVisible) &&
          <section ref={panelOffer}>
            <section></section>
            <section></section>
            <section>
              <h2 className="h2 text-align-center">{site.trade.results_header}</h2>
            </section>
            <section className="text-align-center">
              <div className="flex-column flex-with-gap-sm">
                <h3 className="text-md">{vehicle.year} {vehicle.make_name} {vehicle.model_name}</h3>
                <div>{vehicle.trim_name} {estimate ? '| ' + formatNumber(parseInt(estimate?.mileage)) + ' miles' : ''}</div>
                {(estimate?.vehicle.vin || estimate?.vin) &&
                  <div>VIN # {estimate.vehicle.vin || estimate.vin}</div>
                }
                {estimate &&
                  <div>Condition: {estimate.condition}</div>
                }
              </div>
            </section>
            <section></section>
            <section className={styles.LP}>
              <section className="primary">
                <section></section>
                <section className="text-md text-align-center">{!leadAvailable && leadGated ? "Enter your information to see your offer" : site.trade.results_est_header}</section>
                <section className="text-align-center">
                  {((leadGated && !leadAvailable) || leadFormVisible) ?
                    <span className="text-xl text-bold blur">{'$00,0000'}</span>
                    :
                    <span className="text-xl text-bold">{formatCurrency(estimate.value_low)} - {formatCurrency(estimate.value_high)}</span>
                  }
                </section>
                {!leadFormVisible && Boolean(estimate.payoff) &&
                  <section className="text-align-center">
                    <span className="text-sm">Payoff: {formatCurrency(estimate.payoff)}</span>
                  </section>
                }
                <section></section>
                {leadFormVisible &&
                  <>
                    <section className="--nopad">
                      <LeadForm ctx={'trade'} {...props} refData={{ trade: estimate }} isLeadFormOpened={true} submitLabel={'Show my trade offer'} onSubmit={data => onLeadSubmit(data)}></LeadForm>
                    </section>
                    <section></section>
                  </>
                }
              </section>
            </section>
            <section></section>
            {!leadFormVisible &&
              <section></section>
            }
            {props.page && !leadFormVisible &&
              <section className="text-align-center">
                <div className="flex-row-column flex-with-gap flex-align-center">
                  <div className="flex-col">
                    <Button theme={['secondary', 'inline']} label={site.trade.button_trade_label} href="/vehicles"></Button>
                  </div>
                  <div className="flex-col">
                    <Button theme={['secondary', 'inline']} label={site.trade.button_sell_label} onClick={e => showLeadForm()}></Button>
                  </div>
                  <div className="flex-col min-b-xs">
                    <Button theme={['icon-secondary', 'icon', 'inline']} label={'Edit'} onClick={e => edit()}><Icon {...props} name="pencil"></Icon></Button>
                  </div>
                  <div className="flex-col max-b-xs">
                    <Button theme={['secondary', 'inline']} label={'Edit'} onClick={e => edit()}>Edit Vehicle</Button>
                  </div>
                </div>
              </section>
            }
            {!props.page && !leadFormVisible &&
              <section className="text-align-center">
                <Button theme={['secondary', 'inline']} label={'Change Vehicle'} onClick={e => reset()}></Button>
              </section>
            }
            {!leadFormVisible &&
              <section>
                <div className="flex-row flex-with-gap flex-align-center">
                  <div className="flex-col">
                    <Button theme={['plain', 'inline']} label={site.trade.button_remove_label} onClick={e => remove(e)}>
                      <span className="text-red"><Icon {...props} name="x"></Icon> {site.trade.button_remove_label}</span>
                    </Button>
                  </div>
                  {props.close &&
                    <div className="flex-col">
                      <Button theme={['plain', 'inline']} label={'Done'} onClick={e => props.close(e)}></Button>
                    </div>
                  }
                </div>
              </section>
            }
          </section>
        }
        {site.trade.disclaimer && estimate &&
          <section className={styles.LP}>
            <Disclaimer disclaimer={site.trade.disclaimer}></Disclaimer>
          </section>
        }

        <section></section>
        <section></section>

    </div>
  )
  
}